<div class="card" id="card-config">
  <div class="head">
    <h1>Agrupamentos</h1>
    <div class="linha">
      <span>lista de agrupamentos</span>
      <button class="btn-nav" routerLink="../agrupamentos/cadastro" *ngIf="verificarPermissao(['cadastro_agrupamento'])">
        Novo agrupamento
      </button>
    </div>
  </div>
  <div class="table-responsive-sm">
    <table class="table">
      <thead>
        <tr>
          <th scope="col">Id</th>
          <th scope="col">Nome</th>
          <th scope="col">Tipo</th>
          <th scope="col">Produto</th>
          <th scope="col"></th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let agrupamento of agrupamentos">
          <td scope="row">{{agrupamento.sr_id}}</td>
          <td>{{agrupamento.vc_nome}}</td>
          <td>{{agrupamento.tipo_agrupamento?.vc_descricao }}</td>
          <td>{{agrupamento.produto?.vc_nome}}</td>
          <td>
            <button class="btn-nav" routerLink="../agrupamentos/atualizar/{{agrupamento.sr_id}}" *ngIf="verificarPermissao(['atualizar_agrupamento'])"> <mat-icon
                class="material-icons-sharp">
                edit
              </mat-icon>Editar</button>
          </td>
          <td>
            <button class="btn-nav" (click)="deletar(agrupamento.sr_id)" *ngIf="verificarPermissao(['deletar_agrupamento'])">
              <mat-icon class="material-icons-sharp del">
                delete_forever
              </mat-icon>Excluir</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-container *ngIf="agrupamentos.length == 0">
    <div class="d-flex justify-content-center">
      <p>Não há agrupamentos cadastrados</p>
    </div>
  </ng-container>
</div>
<div class="load d-flex justify-content-center" *ngIf="loader">
  <mat-progress-spinner diameter=30 class="example-margin" color="primary" mode="indeterminate" value="50">
  </mat-progress-spinner>
</div>
